import { useEffect, useState } from 'react';
import { interviewerApi, mentorApi } from '../services/api';
import { useAuth } from '../context/AuthContext';
import {
  canSubmitContributorApplication,
  ContributorApplication,
} from '../utils/contributorApplications';
import { isInterviewer, isMentor } from '../utils/roles';

export function useMyContributorApplications() {
  const { user, isAuthenticated } = useAuth();
  const [mentor, setMentor] = useState<ContributorApplication | null>(null);
  const [interviewer, setInterviewer] = useState<ContributorApplication | null>(null);
  const [loaded, setLoaded] = useState(!isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated || !user?.email) {
      setMentor(null);
      setInterviewer(null);
      setLoaded(true);
      return;
    }
    let cancelled = false;
    setLoaded(false);
    Promise.all([
      mentorApi.myApplication().then((r) => r.data).catch(() => null),
      interviewerApi.myApplication().then((r) => r.data).catch(() => null),
    ]).then(([mentorApp, interviewerApp]) => {
      if (cancelled) return;
      setMentor(mentorApp);
      setInterviewer(interviewerApp);
      setLoaded(true);
    });
    return () => { cancelled = true; };
  }, [isAuthenticated, user?.email]);

  return {
    mentor,
    interviewer,
    loaded,
    canApplyMentor: !isMentor(user) && canSubmitContributorApplication(mentor),
    canApplyInterviewer: !isInterviewer(user) && canSubmitContributorApplication(interviewer),
  };
}
